import React from "react";
import IsometricImage from "components/util/helpers/icons/IsometricImage";

export const SolutionBackgroundType = {
  WAVE: "WAVE",
  SOLID: "SOLID",
  SQUARES: "SQUARES",
};

export const DEFAULT_SOLID_COLOR = "#0a192f";

export const SOLID_BACKGROUND_COLORS = [
  "#0a192f", "#1a5095", "#212121", "#455A64", "#0097A7", "#00796B",
  "#2065a5", "#1976D2", "#512DA8", "#7B1FA2", "#5D4037", "#ffffff"
];

const isOpaqueHex = (color) =>
  typeof color === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color);

export const getSolutionBackground = (flow) => {
  const background = flow?.presentationSettings?.background;
  return {
    type: background?.type || SolutionBackgroundType.WAVE,
    color: isOpaqueHex(background?.color) ? background.color : DEFAULT_SOLID_COLOR,
  };
};

const SolutionBackground = ({ type }) => {
  if (type === SolutionBackgroundType.SQUARES)
    return (
      <div className="solution-squares">
        <IsometricImage />
      </div>
    );

  if (type === SolutionBackgroundType.SOLID)
    return null;

  return <div className="wave"><span></span><span></span><span></span></div>;
};

// `isSection` is false where the background is painted inside a screen (the brief's
// Desarrollo) rather than being the page's section slot, which the id styles and pads.
export const AnimatedContainer = ({ flow, showTopnav = true, isSection = true, children }) => {
  const { type, color } = getSolutionBackground(flow);
  const isSolid = type === SolutionBackgroundType.SOLID;

  return (
    <div
      id={isSection ? "presentation-section-container" : undefined}
      className={"animated-container w-100 h-100 d-flex justify-content-center align-items-center position-relative " +
        (isSolid ? "solution-bg-solid " : "") +
        (!showTopnav ? "no-topnav " : "")}
      style={isSolid ? { backgroundColor: color } : undefined}
    >
      <SolutionBackground type={type} />
      <div className="w-100 h-100 overflow-hidden d-flex">
        <div className="w-100 d-flex h-100">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SolutionBackground;